import React, { useEffect, useState } from "react";

import useSKU from "../../hooks/useSKU";
import useLocalization from "../../hooks/useLocalization";

import { Box, Stack, Typography, IconButton } from "@mui/material";
import EditSquareIcon from "@mui/icons-material/EditSquare";

import InfoBox from "../layout/InfoBox";

import SkuMatrixModal from "../modals/SkuMatrixModal";

const SkuMatrix = ({ surveyId, skuMatrix, onChange }) => {
  const { getLabel, getMessage } = useLocalization();
  const { getSkus } = useSKU();

  const [skus, setSkus] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    getData();
  }, [skuMatrix]);

  const getData = async () => {
    const items = Array.isArray(skuMatrix?.items) ? skuMatrix.items : [];
    const ids = items
      .map((sku) => (typeof sku === "string" ? sku : sku.skuId || sku.id))
      .filter(Boolean);

    if (ids.length > 0) {
      const skuList = await getSkus({ id: { $in: ids } });
      setSkus(Array.isArray(skuList) ? skuList : []);
      return;
    }

    setSkus([]);
  };

  const handleSave = (newValue) => {
    onChange(newValue);
    setOpenModal(false);
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        gap={1}
      >
        <InfoBox
          label={getLabel("skuMatrix")}
          sx={{ backgroundColor: "#f0f0f0", color: "#777" }}
        >
          {Array.isArray(skus) && skus.length > 0 ? (
            <Stack>
              {skus.map((item) => (
                <Typography sx={{ fontSize: "10px" }}>{item.name}</Typography>
              ))}
            </Stack>
          ) : (
            <Typography sx={{ fontSize: "10px" }}>
              {getMessage("notSet")}
            </Typography>
          )}
        </InfoBox>

        <IconButton onClick={() => setOpenModal(true)}>
          <EditSquareIcon />
        </IconButton>
      </Box>

      <SkuMatrixModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        surveyId={surveyId}
        skuMatrix={skuMatrix}
        onSave={handleSave}
      />
    </>
  );
};

export default SkuMatrix;
